<template>
  <div
    v-if="isAlertShown"
    class="tw-flex tw-items-start tw-justify-between tw-space-x-4 tw-rounded-xl tw-border tw-p-4 tw-text-sm"
    :class="alertClasses"
    role="alert"
  >
    <div class="tw-flex">
      <component
        :is="icons[type]"
        class="tw-mr-2 tw-mt-0.5 tw-hidden tw-h-4 tw-w-4 tw-shrink-0 sm:tw-block"
      />
      <div>
        <div
          v-if="$slots.title"
          class="tw-font-semibold"
          :class="{ 'tw-mb-1': $slots.description }"
        >
          <slot name="title" />
        </div>
        <p v-if="$slots.description">
          <slot name="description" />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from '@/assets/images/icons/info.svg'
import CheckIcon from '@/assets/images/icons/check.svg'
import { computed, ref } from 'vue'

const props = defineProps<{
  type: 'warning' | 'error' | 'info' | 'success' | 'neutral'
  isBlock?: string
}>()

const types = {
  warning: 'tw-bg-warning-50 tw-text-warning-900 tw-border-warning-300',
  error: 'tw-bg-error-50 tw-text-error-700 tw-border-error-200',
  info: 'tw-bg-primary-50 tw-text-primary-500 tw-border-primary-200',
  success: 'tw-bg-success-50 tw-text-success-700 tw-border-success-200',
  neutral: 'tw-bg-neutral-50 tw-text-neutral-700 tw-border-neutral-200',
}

const icons = {
  warning: InfoIcon,
  error: InfoIcon,
  info: InfoIcon,
  success: CheckIcon,
  neutral: InfoIcon,
}

const isAlertShown = ref(true)

const alertClasses = computed(() => [
  types[props.type],
  { 'tw-w-full': props.isBlock },
])
</script>
